import React from 'react';

const SettingPortal = () => {
    return (
        <div className='settingPortal'>
            <div className='row'>
                <div className='col-lg-12'>

                </div>
            </div>
        </div>
    );
};

export default SettingPortal;